if (!customElements.get("message-window")) {
  class MessageWindow extends HTMLElement {
    constructor() {
      super();
      this.autoCloseTimer = null;
      this.hideTimer = null;

      this.addEventListener("click", (event) => {
        event.stopPropagation();
        this.close();
      });

      this.querySelectorAll("[data-message-close]").forEach((button) => {
        button.addEventListener("click", () => this.close());
      });

      window.addEventListener("messageOpen", (event) => {
        if (event.detail.id == this.id) this.open();
      });

      window.addEventListener("messageClose", () => this.close());
      window.addEventListener("escPressed", () => this.close());
    }

    // Each window owns its timers and closes only itself: a second popup
    // opened within the auto-close window must not be killed by the first
    // one's timer, and re-opening must cancel a pending hide.
    open() {
      clearTimeout(this.autoCloseTimer);
      clearTimeout(this.hideTimer);
      this.style.display = "flex";
      setTimeout(() => {
        this.classList.add("message-window--opened");
      });
      this.autoCloseTimer = setTimeout(() => {
        this.close();
      }, 5000);
    }

    close() {
      clearTimeout(this.autoCloseTimer);
      clearTimeout(this.hideTimer);
      this.classList.remove("message-window--opened");
      this.hideTimer = setTimeout(() => {
        this.style.display = "none";
      }, 400);
      window.dispatchEvent(new CustomEvent("messageClosed"));
    }
  }

  customElements.define("message-window", MessageWindow);
}
